import React, { Component } from 'react'
import { Notice, Button, HelpEmail } from 'components'
import { AnalyticsUtils } from 'utils'
import { GOOGLE_SEARCH_CONSOLE_VERIFY_BASE_URI } from 'consts'

export default class SiteUnverifiedError extends React.Component {
  static propTypes = {
    user: React.PropTypes.object.isRequired,
    site: React.PropTypes.string
  }

  componentWillMount() {
    AnalyticsUtils.searchConsoleErrorViewed(this.props.user.email, "site_unverified")
  }

  body() {
    return (
      <div>
        <p>Before you can start tracking your SEO data you must verify that you own the site you have selected.</p>
        <p className="small-spacing--top">Have questions? Email us at <HelpEmail /></p>
        <div className="medium-spacing--top">
          <Button
            label="Verify Site"
            buttonType="primary"
            href={`${GOOGLE_SEARCH_CONSOLE_VERIFY_BASE_URI}${this.props.site}`}
            target="_blank"
          />
        </div>
      </div>
    )
  }

  render() {
    return <Notice 
      error={true}
      header="Cannot Access Search Console: Your Site is Unverified"
      note={this.body()}
      className="xlarge-spacing2--bottom" />
  }
}



// WEBPACK FOOTER //
// ./app/components/search_console/partials/SiteUnverifiedError.js